import axios from '@/configs/Axios'
const payloadParams = (payload) => {
    if(payload) {
        let reqData = "";
        Object.keys(payload).forEach(key => {
            reqData += key + "=" + payload[key] + "&"
        })
        reqData = reqData.substr(0, reqData.lastIndexOf("&"))
        return '?'+reqData
    } else return ''
}
const queryCheck = (query, keys) => {
    let queryFilter = {}
    if(query) {
        for (const key in query) {
            keys.forEach(item => {
                if(key === item) queryFilter[item] = query[key]
            })
        }
        return payloadParams(queryFilter)
    } return ''
}
const state = () => ({
    vedomosti:[],
    vedomost:{},
    mark:[],
    access:false,
    blocking_vedomosti:[],
    close:null,
    study_year: [],
    teacher: [],
    acad_period: [],
    eduGroup: [],
    statement_type: [],
    discipline: [],
    type_of_statement: [],
    form_of_control: [],
    statement_status: [],
    vedomosti_history:[]

})

const getters = {
    GET_VEDOMOSTI:state=>state.vedomosti,
    GET_VEDOMOST:state=>state.vedomost,
    GET_MARK:state=>state.mark,
    GET_ACCESS:state=>state.access,
    GET_BLOCKING_VEDOMOSTI:state=>state.blocking_vedomosti,
    GET_CLOSE:state=>state.close,
    GET_VEDOMOSTI_HISTORY:state=>state.vedomosti_history,

}

const mutations = {
    SET_VEDOMOSTI(state,value){
        state.vedomosti = value
    },
    SET_VEDOMOST(state,value){
        state.vedomost = value
    },
    SET_MARK(state,value){
        state.mark = value
    },
    SET_ACCESS(state,value){
        state.access = value.access
    },
    CHANGE_MARK_PROGRESS_OF_STUDENTS(state,value){
        const index = state.mark.findIndex(
            (el) => el.uid === value.data
        );
        if(index !== -1) {
            state.mark[index].mark = value.mark
        }

    },
    CHANGE_REASON_PROGRESS_OF_STUDENTS(state,value){
        // console.log(Object.keys(value))
        const index = state.mark.findIndex(
            (el) => el.uid === value.data
        );
        if(index !== -1) {
            state.mark[index].reason = value.reason
        }

    },
    CHANGE_MISSED_PROGRESS_OF_STUDENTS(state,value){
        // console.log(Object.keys(value))
        const index = state.mark.findIndex(
            (el) => el.uid === value.data
        );
        if(index !== -1) {
            state.mark[index].missed = value.missed
            state.mark[index].mark = value.mark
        }

    },
    SLICE_NUMBER(state,value){
        state.mark[value.index][value.event.key] = Number(value.number)
    },
    SET_BLOCKING_VEDOMOSTI(state,value){
        state.blocking_vedomosti = state.blocking_vedomosti.concat(value);
    },
    CHANGE_STATUS(state, value) {
        state.blocking_vedomosti[value.index].closed = value.status
        state.blocking_vedomosti[value.index].edited = !state.blocking_vedomosti[value.index].edited
    },
    CHANGE_CLOSE(state,value){
        state.close = value
    },
    SET_SELECT_FILTER(state, payload) {
        state[payload.key] = payload.value
    },
    CLEAR_FILTER_BY_KEY(state, payload) {
        payload.forEach(key => {
            state[key] = []
        })
    },
    CLEAR_JOURNAL_LIST(state) {
        state.blocking_vedomosti = []
    },
    SET_VEDOMOSTI_HISTORY(state,value) {
        state.vedomosti_history = value
    },
    CHANGE_VEDOMOSTI(state,value){
        state.vedomost.status_statements = value
    },
    CLEAR_SELECT_LIST(state, key) {
        state[key] = []
    }

}

const actions = {
    VEDOMOSTI: async ({commit},payload) => {
        const query = {
            ...payload.route.query
        }
        await axios.get(`/schedules/vedomosti/all_list/${ payloadParams(query) }`)
            .then(function (resp) {
                commit('SET_VEDOMOSTI', resp.data)
            }).catch(function (resp) {
                console.log(resp)
            })
    },
    VEDOMOST: async ({commit},payload) => {
        await axios.get(`/schedules/vedomosti/${ payload }/`)
            .then(function (resp) {
                commit('SET_VEDOMOST', resp.data)
            }).catch(function (resp) {
                console.log(resp)
            })
    },
    MARK: async ({commit,state},payload) => {
        await axios.get(`/schedules/vedomosti/mark/?uid=${ payload.uid }&study_plan_uid_1c=${ payload.study_plan_uid_1c }`)
            .then(function (resp) {
                commit('SET_MARK', resp.data)
            }).catch(function (resp) {
                console.log(resp)
            })
    },
    ACCESS: async ({commit,state},payload) => {
        await axios.get(`/schedules/vedomosti/access/?uid=${ payload.uid }&study_plan=${ payload.study_plan }`)
            .then(function (resp) {
                commit('SET_ACCESS', resp.data)
            }).catch(function (resp) {
                console.log(resp)
            })
    },
    BLOCKING_VEDOMOSTI ({ commit }, payload) {
        return new Promise((resolve, reject) => {

            const query = {
                page: payload.page,
                ...payload.route.query
            }

            axios.get(`/schedules/blocking_vedomosti/all_list/${ payloadParams(query) }`)
                .then(({data}) => {
                    if(typeof data === 'object') {
                        commit('SET_BLOCKING_VEDOMOSTI', data.results)
                        resolve(data)
                    } else resolve(false)
                })
                .catch((error) => { reject(error) })
        })
    },
    // BLOCKING_VEDOMOSTI:async ({commit},payload)=>{
    //     console.log(payload)
    //     const query = {
    //         page: payload.page,
    //         ...payload.route.query
    //     }
    //     await axios.get(`/schedules/blocking_vedomosti/all_list/${ payloadParams(query) }`)
    //         .then(function (resp) {
    //             commit('SET_BLOCKING_VEDOMOSTI', resp.data.results)
    //         }).catch(function (resp) {
    //             console.log(resp)
    //         })
    // },
    checkSelectType({commit, state}, payload) {
        return new Promise((resolve, reject) => {

            let endpoint,
                getParams = '';

            switch(payload.type) {
                case 'study_year':
                    endpoint = '/common/study_years/'
                    break;
                case 'teacher':
                    getParams = queryCheck(payload.query, ['study_year'])
                    // условие, вставляет имя модуля в запрос, нужно для бека
                    if(getParams.length > 1){
                        getParams += '&module=vedomosti'
                    } else getParams = '?module=vedomosti'
                    endpoint = '/schedules/teachers/'
                    break;
                case 'discipline':
                    endpoint = '/schedules/disciplines/'
                    break;
                case 'acad_period':
                    endpoint = '/common/acad_periods/'
                    break;

                case 'eduGroup':
                    endpoint = '/schedules/groups/'
                    break;

                case 'statement_type':
                    endpoint = '/schedules/statement_type/'
                    break;

                case 'form_of_control':
                    endpoint = '/schedules/control_form/'
                    break;

                case 'statement_status':
                    endpoint = '/schedules/status_statements/'
                    break;

                case 'type_of_statement':
                    endpoint = '/schedules/type_of_statement/'
                    break;
            }

            if(endpoint) {
                if(!state[payload.type].length) {
                    axios.get(`${ endpoint }${ getParams }`)
                        .then(({data}) => {
                            commit('SET_SELECT_FILTER', {key: payload.type, value: data})
                            resolve(data)
                        })
                        .catch((error) => { reject(error) })
                } else
                    resolve(state[payload.type])
            } else
                resolve(state.status)
        })
    },
    VEDOMOSTI_HISTORY: async ({commit,state},payload) => {
        await axios.get(`/schedules/vedomosti/history/`,{
            params:{
                vedomosti:payload.id
            }
        })
            .then(function (resp) {
                commit('SET_VEDOMOSTI_HISTORY', resp.data)
            }).catch(function (resp) {
                console.log(resp)
            })
    }

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
